/* eslint-disable */
import SettingProviderStorage from '@produtos/store-setting-provider/src/storage';
import axios from 'axios';
import { getPathAxiosInstance } from './get-path';

export default class AxiosInjectClass {
  axiosInstance = null;
  token = null;

  constructor() {
    this.setInterceptors();
  }

  setInterceptors() {
    if (!this.axiosInstance) {
      this.axiosInstance = axios.create();

      const storage = new SettingProviderStorage();
      this.axiosInstance.interceptors.request.use(
        async (config) => {
          if (!this.token) {
            const { id } = await storage.getCookieToken();
            this.token = id;
          }

          if (this.token) {
            /* eslint-disable no-param-reassign */
            config.headers['access-control-expose-headers'] = 'X-Total-Count';
            config.headers.Authorization = this.token;
          }

          return config;
        },
        (error) => Promise.reject(error),
      );

      this.axiosInstance.interceptors.response.use((response) => response, (error) => {
        if (error?.status === 401) {
          storage.eraseToken().finally(() => {
            location.reload();
          });
        } else {
          return Promise.reject(error);
        }
      });
      storage.getCookieToken()
        .then(({ id }) => {
          this.token = id;
        });
    }
  }

  async get(servicename, endpoint, config = {}) {
    return this.axiosInstance.get(await getPathAxiosInstance(this, servicename, endpoint), config);
  }

  async post(servicename, endpoint, data = {}, config = null) {
    return this.axiosInstance.post(await getPathAxiosInstance(this, servicename, endpoint), data, config);
  }

  async put(servicename, endpoint, data = {}, config = null) {
    return this.axiosInstance.put(await getPathAxiosInstance(this, servicename, endpoint), data, config);
  }

  async patch(servicename, endpoint, data = {}, config = null) {
    return this.axiosInstance.patch(await getPathAxiosInstance(this, servicename, endpoint), data, config);
  }

  async delete(servicename, endpoint, config = null) {
    return this.axiosInstance.delete(await getPathAxiosInstance(this, servicename, endpoint), config);
  }

  async upload(servicename, endpoint, data, config = null) {
    if (!config) config = {};
    config['headers']['Content-Type'] = 'multipart/form-data';
    return this.axiosInstance.post(await getPathAxiosInstance(this, servicename, endpoint), data, config);
  }

  getUrl() {
    return this.axiosInstance.defaults.baseURL;
  }
}
/* eslint-enable */
